import React from 'react';
import ControlDialog from 'swag-client-common/components/info/control-dialog';
import KickstarterShippingStepper from './components/kickstarter-shipping-stepper';
function KickstarterShippingPopup({
  onClose,
  step,
  uploadState,
  onApproveProposal,
  onCSVUpload,
  ksFulfillment,
  invalidAddresses,
  totalAmount,
  validCount,
  parsingProgress,
  parsingShipmentPrice,
  progressIsDone,
  onProgressStep,
  onChangeStep,
  onAddToOrder,
  error
}) {
  return /*#__PURE__*/React.createElement(ControlDialog, {
    open: true
    // @todo. auto generated. fix this error
    // @ts-ignore
    ,
    bodyStyle: {
      padding: '70px 30px',
      backgroundColor: '#F8F9FA'
    }
    // @todo. auto generated. fix this error
    // @ts-ignore
    ,
    actionsContainerStyle: {
      padding: 0
    },
    onRequestClose: onClose,
    content: /*#__PURE__*/React.createElement(KickstarterShippingStepper, {
      step: step,
      ksFulfillment: ksFulfillment,
      totalAmount: totalAmount,
      validCount: validCount,
      uploadState: uploadState,
      invalidAddresses: invalidAddresses,
      onClose: onClose,
      onApproveProposal: onApproveProposal,
      onCSVUpload: onCSVUpload,
      parsingProgress: parsingProgress,
      parsingShipmentPrice: parsingShipmentPrice,
      progressIsDone: progressIsDone
      // @ts-ignore
      ,
      onProgressStep: onProgressStep,
      onChangeStep: onChangeStep,
      onAddToOrder: onAddToOrder,
      error: error
    })
  });
}
export default KickstarterShippingPopup;